export const menuTemplate = {
  singleDish: 'single_dish',
  doubleDish: 'double_dish',
  videoDish: 'video_dish', // sẽ không có extra feature này. Cái  này do FE định nghĩa
}

export const menuTemplateDefault = 'default'
